import { Link } from 'react-router-dom';
import { useHome } from '../../../hooks/useHome';
import { pathImages } from '../../../routes/endpoints';
import { useEffect } from 'react';

export const Instituciones = () => {
    const { instituciones, getInstituciones } = useHome();

    useEffect(() => {
        getInstituciones();
    }, []);

    const chunkSize = 5;

    const dividedData = [];

    for (let i = 0; i < instituciones.length; i += chunkSize) {
        const chunk = instituciones.slice(i, i + chunkSize);
        dividedData.push(chunk);
    }

    return (
        <div className="container py-4" role='group' aria-label='instituciones'>
            <div className="row">
                <div id="carouselExample" className="carousel slide">
                    <div className="carousel-inner">
                        {dividedData.map((group, i) => (
                            <div key={i} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                                <div className="row px-5 justify-content-center">
                                    {group.map(({ id, imagen, url }) => (
                                        url ?
                                            <div key={id} className="col-md-2 col-6">
                                                <Link key={id} to={url} target='_blank' role='link' aria-label="ir a link">
                                                    <img src={`${pathImages}${imagen}`} className="d-block img-fluid w-100" alt="..." />
                                                </Link>
                                            </div>
                                            :
                                            <div className="col-md-2 col-6" key={id}>
                                                <img src={`${pathImages}${imagen}`} className="d-block img-fluid w-100" alt="..." />
                                            </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev" role='button' aria-label='ir a anterior'>
                        <span className="carousel-control-prev-icon bg-btn-carrusel" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next" role='button' aria-label='ir a siguiente'>
                        <span className="carousel-control-next-icon bg-btn-carrusel" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
